import { createAsyncAtom } from '../../lib/state';

function createInputAtom() {
  const atom = createAsyncAtom<string>(async () => '');
  const set = (value: string) => atom.setValue(value);
  const reset = () => atom.setValue('');
  return { atom, set, reset };
}

export const depositInput = createInputAtom();
export const withdrawInput = createInputAtom();
export const borrowInput = createInputAtom();
export const repayInput = createInputAtom();
